import { render, staticRenderFns } from "./MediaName.vue?vue&type=template&id=4809d141&"
import script from "./MediaName.vue?vue&type=script&lang=js&"
export * from "./MediaName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports